import { ui } from '../../styles/ui'

export default function PageHeader({
  title,
  subtitle,
  actions,
  className = '',
}) {
  return (
    <div className={`${ui.layout.pageHeader} ${className}`.trim()}>
      <div>
        <h1 className={ui.layout.pageTitle}>{title}</h1>
        {subtitle ? <p className={`${ui.layout.pageSubtitle} mt-1`}>{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  )
}
